import React from 'react';
import About1 from '../../images/about/about-8.jpg';
import About2 from '../../images/about/about-9.jpg';
import About3 from '../../images/about/about-10.jpg';
import Shape from '../../images/about/shape13.png';
import Shape2 from '../../images/about/shape10.svg';
import Call from '../../images/about/call.svg';
import aut1 from '../../images/about/aut-1.jpg';
import aut2 from '../../images/about/aut-2.jpg';
import aut3 from '../../images/about/aut-3.jpg';
import { useLanguage } from '../../context/LanguageContext';

const AboutS2 = (props) => {
    const { t } = useLanguage();

    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <div className="about-image">
                            <div className="image1">
                                <img src={About1} alt="Evcil Hayvan Sağlığı" />
                            </div>
                            <div className="image2">
                                <img src={About2} alt="Veteriner Onaylı Bakım" />
                                <div className="shape">
                                    <img src={Shape} alt="Dekoratif Şekil" />
                                </div>
                            </div>
                            <div className="image3">
                                <img src={About3} alt="Mutlu Kedi ve Köpekler" />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="right-content">
                            <h3>{t('about2.heading1')} <span> {t('about2.heading2')} </span>{t('about2.heading3')}</h3>
                            <p>{t('about2.p1')}</p>
                            <p>{t('about2.p2')}</p>
                            <div className="author-wrap">
                                <ul className="author-img">
                                    <li><img src={aut1} alt="Müşteri Memnuniyeti 1" /></li>
                                    <li className="active"><img src={aut2} alt="Müşteri Memnuniyeti 2" /></li>
                                    <li><img src={aut3} alt="Müşteri Memnuniyeti 3" /></li>
                                </ul>
                                <div className="author-text">{t('about2.customers')} <div className="shape"><img src={Shape2} alt="Şekil İkonu" /></div></div>
                                <div className="contact">
                                    <div className="icon">
                                        <img src={Call} alt="VitAnimal İletişim Telefonu" />
                                    </div>
                                    <div className="text">
                                        <span>{t('about2.phone')}</span>
                                        <h4>0 531 775 57 54</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutS2;
